// extracted by mini-css-extract-plugin
export default {"wrapper":"template_wrapper__zzAXe","slider":"template_slider__oN0NH","content":"template_content__ujFpY"};